const miniCartContainer = document.querySelector(".cart-drawer-modal");
const miniCart = document.querySelector(".cc-popup-modal");
const icons = document.querySelectorAll(".cart-link");

function cartClose() {
  if (!miniCartContainer) return;
  miniCartContainer.classList.remove("cc-popup--visible");
  document.body.classList.remove("cc-popup-no-scroll");
  document.body.style.padding = "0";
  const quickbuyContainer = document.querySelector(
    ".minicart-quickbuy-container",
  );
  if (quickbuyContainer && quickbuyContainer.classList.contains("open")) {
    quickbuyContainer.classList.remove("open");
    quickbuyContainer.querySelector(".inner")?.replaceChildren();
  }
}

function cartActive() {
  if (!miniCartContainer) return;
  miniCartContainer.classList.add("cc-popup--visible");
}

function cartToggle(event) {
  event.preventDefault();
  if (!miniCartContainer) return;
  if (miniCartContainer.classList.contains("cc-popup--visible")) {
    cartClose();
  } else {
    cartActive();
  }
}

if (miniCartContainer) {
  icons.forEach((icon) => {
    icon.addEventListener("click", cartToggle);
  });

  document.addEventListener("click", (event) => {
    if (!miniCartContainer.classList.contains("cc-popup--visible")) return;
    const clickedIcon = [...icons].some((icon) => icon.contains(event.target));
    if (clickedIcon) return;
    if (!miniCart?.contains(event.target)) {
      cartClose();
    }
  });
}
